<template>
  <empty-view :title="$t('page_not_found')" />
</template>

<script>
import EmptyView from "@/layouts/components/Empty";
export default {
  name: "NotFound",
  components: { EmptyView },
};
</script>

<style scoped></style>
